<div class="row" *ngIf="!readonly">
    <div class="col-sm-12">
        <div class="row no-gutters">
            <div class="col-sm-12">
                <div class="smp-title-thin-border full-width mb-3">
                    {{ 'editable_comments.title.add_comment' | translate }}
                </div>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col-sm-12">
                <mat-form-field class="full-width">
                    <textarea id="{{idPrefix}}new_comment"
                              matInput
                              rows="6"
                              [(ngModel)]="newComment"
                              [disabled]="disabled">
                    </textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="offset-sm-6 col-sm-6">
                <div class="bottom-buttons">
                    <a id="{{idPrefix}}new_comment.btn.save"
                       mat-button
                       style="float: right;"
                       (click)="createComment()"
                       [disabled]="disabled">{{ 'common.btn.save' | translate }}
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="row" *ngFor="let comment of comments; let idx = index">
    <div class="col-sm-12">
        <div class="row no-gutters">
            <div class="col-sm-12">
                <div class="smp-title-thin-border full-width mb-3">
                    {{ comment.last_modification_date | drDateTime }} - {{ comment.author }}

                    <button id="{{idPrefix}}comment_{{idx}}.btn.edit"
                            mat-icon-button
                            class="edit-btn"
                            *ngIf="isMyComment(comment) && !readonly"
                            (click)="toggleEditMode(comment)"
                            [disabled]="disabled">
                        <mat-icon class="dr-material-icon"
                                  [ngClass]="{ 'disabled': disabled }"
                                  [matTooltip]="'common.btn.edit' | translate">create
                        </mat-icon>
                    </button>

                    <button id="{{idPrefix}}comment_{{idx}}.btn.delete"
                            mat-icon-button
                            class="delete-btn"
                            *ngIf="isMyComment(comment) && !readonly"
                            (click)="deleteComment(comment)"
                            [disabled]="disabled">
                        <mat-icon class="dr-material-icon"
                                  [ngClass]="{ 'disabled': disabled }"
                                  [matTooltip]="'common.btn.delete' | translate">clear
                        </mat-icon>
                    </button>

                </div>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col-sm-12">
                <div class="smp-formatted-text-div mb-3"
                     *ngIf="!isEditable(comment)"
                     [innerHTML]="comment.comment">
                </div>

                <mat-form-field class="full-width"
                                *ngIf="isEditable(comment)">
                    <textarea id="{{idPrefix}}comment_{{idx}}.text"
                              matInput
                              rows="6"
                              [(ngModel)]="comment.comment">
                    </textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="offset-sm-6 col-sm-6">
                <div class="bottom-buttons">
                    <a id="{{idPrefix}}comment_{{idx}}.btn.save"
                       mat-stroked-button
                       color="accent"
                       *ngIf="isEditable(comment)"
                       style="float: right;margin: 5px 0 0 5px;"
                       [disabled]="disabled"
                       (click)="updateComment(comment)">{{ 'common.btn.save' | translate }}
                    </a>

                    <a id="{{idPrefix}}comment_{{idx}}.btn.cancel"
                       mat-stroked-button
                       color="primary"
                       *ngIf="isEditable(comment)"
                       style="float: right;margin: 5px 0 0 5px;"
                       [disabled]="disabled"
                       (click)="cancelUpdate(comment)">{{ 'common.btn.cancel' | translate }}
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>
